// extracted by mini-css-extract-plugin
export default {"card":"ClientLoanProgramDetailPage_card__Udv+p","title":"ClientLoanProgramDetailPage_title__rjgGs","button":"ClientLoanProgramDetailPage_button__WAF9C"};